export default {
  public_layout: {
    login: 'Login',
    cookies: {
      title: 'Política de cookies',
      text: 'SorareMega usa cookies para recolectar datos que ayudan a proporcionarle una mejor experiencia de usuario',
      learn_more: 'Para saber más, por favor revise nuestra',
      privacy_policy: 'Política de Privacidad',
      accept: 'Aceptar',
      decline: 'Decline',
    },
  },
  home: {
    enter_the_arena: 'Entra a la Arena',
    leagues_score_dice_cups: 'Ligas • Score Dice • Copas',
    start_playing_now: 'Empiece a jugar ahora',
  },
  login: {
    login_with_sorare: 'Entre con su cuenta de Sorare',
    dont_have_sorare_account: 'No tiene una cuenta de Sorare?',
    create_one_now: 'Cree una ahora',
  },
  coming_soon: {
    soraremega_will_come_back_soon: 'SorareMega regresará pronto',
    enter_email: 'Introduce tu correo electrónico para mantenerte informado y recibir las últimas novedades',
    submit: 'Entregar',
    success_message: 'Gracias por su registro',
  },
  nav: {
    help: 'Ayuda',
    logout: 'Desconexión',
  },
  manager_profile: {
    gallery: 'GALERÍA',
  },
  mega_league_result: {
    my_fixture: 'Mi enfrentamiento',
    leaderboard: 'Clasificación',
    fixtures: 'Enfrentamientos',
    no_fixture_for_this_gw: 'Sin enfrentamiento',
  },
  beta_tester: {
    only_for_beta_tester: 'Solo para beta testers',
  },
  game_week: {
    ended: 'FINALIZADO',
    waiting: 'ESPERA',
    live: 'DIRECTO',
    open: 'ABIERTO',
  },
  lobby: {
    play: 'Jugar',
    edit: 'Editar',
    live_results: 'En directo',
    results: 'Resultados',
  },
  filter_menu: {
    filter: 'Filtrar',
    playing_this_gw: 'Jugando esta GW',
    show_last_5_score: 'Muestra las últimas 5 puntuaciones',
  },
  filter_drawer: {
    sort_by: 'Ordenar por',
    scarcity: 'Rareza',
    position: 'Posición',
    last_recruits: 'Últimos fichajes',
    name: 'Nombre',
    unique: 'Única',
    super_rare: 'Muy rara',
    rare: 'Rara',
    limited: 'Limitada',
    forward: 'Delantero',
    midfielder: 'Mediocentro',
    defender: 'Defensor',
    goalkeeper: 'Portero',
  },
  formation: {
    formation: 'Formación',
  },
  status: {
    confirmed: 'Confirmado',
    not_confirmed: 'No confirmado',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
  },
  card_picker: {
    no_card_picked: 'Carta no elegida',
  },
  pick_card_dialog: {
    player_pick: 'Elegir jugador',
  },
  first_login_dialog: {
    settings : 'Ajustes',
    email_address : 'Dirección de correo electrónico',
    save : 'Guardar',
    invalid_email : 'Correo electrónico no válido',
  },
  user_lineup_dialog:{
    unable_to_load_lineup: 'No se puede cargar el equipo',
  },
  lineup_header:{
    average_per_free_position: 'Promedio por posición libre :',
  },
  stats: {
    yellow_card: 'Tarjeta amarilla',
    foul: 'Falta',
    was_fouled: 'Faltas señaladas',
    error_lead_to_shot: 'Error que provoca un penalti',
    clean_sheet: 'Portería a cero',
    goal_conceded: 'Gole concedido',
    effective_clearance: 'Saque de puerta efectivo',
    won_tackle: 'Entrada ganada',
    blocked_cross: 'Centro bloqueado',
    outfielder_block: 'Bloqueo de jugador de campo',
    possession_lost: 'Pérdida de posesión',
    possession_won: 'Posesión ganada',
    duel_lost: 'Duelo perdido',
    duel_won: 'Duelo ganado',
    interception_won: 'Intercepción lograda',
    big_chance_created: 'Gran ocasión creada',
    attempted_assist: 'Intento totale de asistencia',
    accurate_pass: 'Pase logrado',
    accurate_final_third_pass: 'Pase de tres cuartos de campo con éxito',
    accurate_long_ball: 'Balón en largo preciso',
    accurate_own_to_opposite_pass: 'Pase largo adelante',
    missed_pass: 'Pase fallido',
    shot_on_target: 'Disparo a puerta',
    won_contest: 'Pugna ganada',
    penalty_area_entry: 'Falta en el área pequeña',
    penalty_kick_missed: 'Penalti fallado',
    big_chance_missed: 'Ocasión fallida',
    save: 'Paradas',
    saved_shot_from_inside_box: 'Salida de portero precisa',
    good_high_claim: 'Centro por alto bloqueado',
    punch: 'Golpe',
    dive_save: 'Parada en salto',
    dive_catch: 'Bloqueo en salto',
    cross_not_claimed: 'Centro no despejado',
    six_second_violation: 'Falta de seis segundos',
    gk_smother: 'Parada frontal',
    keeper_sweeper: 'Salida de portero precisa',
  },
  splitted_score: {
    decisive: 'Decisiva',
    all_around: 'Total',
  },
  snackbar: {
    team_successfully_confirmed: 'Equipo confirmado con éxito',
    duplicated_card: 'Carta duplicada',
    duplicated_player: 'Jugador duplicado',
    invalid_captain: 'Capitán inválido',
    missing_captain: 'Capitán ausente',
    invalid_formation: 'Formación inválida',
    invalid_ownership: 'Propietario inválido',
    invalid_position: 'Posición inválida',
    invalid_scarcity: 'Escasez no válida',
    invalid_edition: 'Edición inválida (leyenda)',
    goalkeeper_required: 'Portero requerido',
    invalid_goalkeeper: 'Portero inválido',
    invalid_defenders: 'Defensores inválidos',
    invalid_midfielders: 'Mediocentros inválidos',
    invalid_forwards: 'Delanteros inválidos',
    team_canceled: 'Equipo cancelado',
    cap_exceeded: 'Límite excedido',
    max_players_per_team: 'Demasiados jugadores en el mismo equipo, máximo 3 permitidos'
  },
  mega_league: {
    tabs: {
      my_team: 'Mi equipo',
      leaderboard: 'Clasificación',
    }
  }
};
